import { IAccess } from "../interfaces";

/**
 * Enum for user roles in the system
 */
export const UserRole = {
  ADMIN: "ADMIN",
  MANAGER: "MANAGER",
  OPS: "OPS",
  SALES: "SALES",
  SUPPORT: "SUPPORT",
  USER: "USER",
};

/** Query param for deep-linking to a user/customer from list pages (`?userId=`). */
export const USER_ID_QUERY_PARAM = "userId";

/** Query param for filtering subscriptions by order from list pages (`?orderId=`). */
export const ORDER_ID_QUERY_PARAM = "orderId";

/**
 * some constants for userspage
 */
export const includePets = true;
export const pageSize = 20;

export const SUPER_USERS: string[] = [UserRole.ADMIN, UserRole.MANAGER];

export const DEFAULT_ACCESS: IAccess = {
    view: [...SUPER_USERS, UserRole.OPS],
    edit: SUPER_USERS,
}

export const ADMIN_ONLY: IAccess = {
    view: [UserRole.ADMIN, UserRole.MANAGER],
    edit: [UserRole.ADMIN],
}

export const ADMIN_MANAGER_OPS: IAccess = {
    view: [...SUPER_USERS, UserRole.OPS],
    edit: [...SUPER_USERS, UserRole.OPS],
}

export const ADMIN_MANAGER_SALES: IAccess = {
    view: [...SUPER_USERS, UserRole.SALES],
    edit: [...SUPER_USERS, UserRole.SALES],
}

export const NOT_LOGGED_IN_USERS: IAccess = {
    view: [],
    edit: [],
}

/**
 * V4 User types and roles
 */

export enum EUserTypeV4 {
    CUSTOMER = "CUSTOMER",
    PARTNER = "PARTNER",
    STAFF = "STAFF",
    SYSTEM = "SYSTEM",
}

export enum EUserRoleV4 {
    ADMIN = "ADMIN",
    MANAGER = "MANAGER",
    OPS = "OPS",
    SALES = "SALES",
    SUPPORT = "SUPPORT",
}